module.exports = [
  {
    countries: ['pl', 'cz', 'hu', 'sk'],
    key: 'wintersports_alpineskiing',
    pageName: 'AlpineSkiingSearchPage',
    translationKey: 'urls.alpineskiingRent',
    headerKey: 'SearchPage.alpineskiingHeader',
    descriptionKey: 'SearchPage.alpineskiingDescription',
    metaTitleKey: 'SearchPage.alpineskiingMetaTitle',
    metaDescriptionKey: 'SearchPage.alpineskiingMetaDescription',
    tags: {
      'pl': ['narty męskie', 'narty damskie', 'narty dziecięce',  'buty narciarskie', 'kijki narciarskie' ],
      'cz': ['pánské lyže', 'dámské lyže', 'dětské lyže',  'pánské lyžařské boty', 'dámské lyžařské boty', 'dětské lyžařské boty'],
      'hu': ['női síléc', 'férfi síléc', 'gyerek síléc',  'síbakancs', 'síbot']
    },
  },
  {
    countries: ['sk'],
    key: 'wintersports_skitouring',
    pageName: 'SkiTouringSearchPage',
    translationKey: 'urls.skiTouringRent',
    headerKey: 'SearchPage.skiTouringHeader',
    descriptionKey: 'SearchPage.skiTouringDescription',
    metaTitleKey: 'SearchPage.skiTouringMetaTitle',
    metaDescriptionKey: 'SearchPage.skiTouringMetaDescription',
  },
  {
    countries: ['cz', 'sk'],
    key: 'wintersports_seasonalski',
    pageName: 'SeasonalSkiSearchPage',
    translationKey: 'urls.seasonalskiRent',
    headerKey: 'SearchPage.seasonalskiHeader',
    descriptionKey: 'SearchPage.seasonalskiDescription',
    metaTitleKey: 'SearchPage.seasonalskiMetaTitle',
    metaDescriptionKey: 'SearchPage.seasonalskiMetaDescription',
    tags: {
      'cz': ['dětské lyže', 'pánské lyže', 'dámské lyže', 'dětské lyžařské boty', 'pánské lyžařské boty', 'dámské lyžařské boty']
    },
    
  },
  {
    countries: ['pl', 'cz', 'hu', 'sk', 'lt'],
    key: 'bikes_gravel',
    pageName: 'GravelBikesSearchPage',
    translationKey: 'urls.bikesGravelRent',
    headerKey: 'SearchPage.bikesGravelHeader',
    descriptionKey: 'SearchPage.bikesGravelDescription',
    metaTitleKey: 'SearchPage.bikesGravelMetaTitle',
    metaDescriptionKey: 'SearchPage.bikesGravelMetaDescription',
  },
  {
    countries: ['pl', 'cz', 'sk', 'hu'],
    key: 'bikes_road',
    pageName: 'RoadBikesSearchPage',
    translationKey: 'urls.bikesRoadRent',
    headerKey: 'SearchPage.bikesRoadHeader',
    descriptionKey: 'SearchPage.bikesRoadDescription',
    metaTitleKey: 'SearchPage.bikesRoadMetaTitle',
    metaDescriptionKey: 'SearchPage.bikesRoadMetaDescription',
  },
  {
    countries: ['pl', 'cz', 'hu'],
    key: 'bikes_trekking',
    pageName: 'TrekkingBikesSearchPage',
    translationKey: 'urls.bikesTrekkingRent',
    headerKey: 'SearchPage.bikesTrekkingHeader',
    descriptionKey: 'SearchPage.bikesTrekkingDescription',
    metaTitleKey: 'SearchPage.bikesTrekkingMetaTitle',
    metaDescriptionKey: 'SearchPage.bikesTrekkingMetaDescription',
  },
  {
    countries: ['pl', 'cz', 'sk', 'hu', 'lt'],
    key: 'bikes_electric',
    pageName: 'ElectricBikesSearchPage',
    translationKey: 'urls.bikesElectricRent',
    headerKey: 'SearchPage.bikesElectricHeader',
    descriptionKey: 'SearchPage.bikesElectricDescription',
    metaTitleKey: 'SearchPage.bikesElectricMetaTitle',
    metaDescriptionKey: 'SearchPage.bikesElectricMetaDescription',
  },
  {
    countries: ['pl', 'cz', 'sk'],
    key: 'bikes_trailer',
    pageName: 'BikesTrailerSearchPage',
    translationKey: 'urls.bikesTrailerRent',
    headerKey: 'SearchPage.bikesTrailerHeader',
    descriptionKey: 'SearchPage.bikesTrailerDescription',
    metaTitleKey: 'SearchPage.bikesTrailerMetaTitle',
    metaDescriptionKey: 'SearchPage.bikesTrailerMetaDescription',
  },
  {
    countries: ['pl', 'cz', 'sk'],
    key: 'tourism_crampons',
    pageName: 'TourismCramponsSearchPage',
    translationKey: 'urls.tourismCramponsRent',
    headerKey: 'SearchPage.tourismCramponsHeader',
    descriptionKey: 'SearchPage.tourismCramponsDescription',
    metaTitleKey: 'SearchPage.tourismCramponsMetaTitle',
    metaDescriptionKey: 'SearchPage.tourismCramponsMetaDescription',
    tags: {
      'pl': ['raczki', 'raki' ]
    },
  },
  {
    countries: ['pl', 'cz', 'hu', 'sk'],
    key: 'wintersports_snowboard',
    pageName: 'WintersportsSnowboardSearchPage',
    translationKey: 'urls.wintersportsSnowboardRent',
    headerKey: 'SearchPage.wintersportsSnowboardHeader',
    descriptionKey: 'SearchPage.wintersportsSnowboardDescription',
    metaTitleKey: 'SearchPage.wintersportsSnowboardMetaTitle',
    metaDescriptionKey: 'SearchPage.wintersportsSnowboardMetaDescription',
    tags: {
      'pl': ['deska snowboardowa', 'buty snowboardowe' ],
      'hu': ['snowboard', 'snowboardbakancs' ],
      'cz': ['pánský snowboard', 'dámský snowboard', 'dětský snowboard', 'pánské snowboardové boty', 'dámské snowboardové boty', 'dětské snowboardové boty']
    },
  },
  {
    countries: ['cz', 'hu', 'lv', 'ee', 'pl'],
    key: 'camping_accessories',
    pageName: 'CampingAccessoriesSearchPage',
    translationKey: 'urls.campingAccessoriesRent',
    headerKey: 'SearchPage.campingAccessoriesHeader',
    descriptionKey: 'SearchPage.campingAccessoriesDescription',
    metaTitleKey: 'SearchPage.campingAccessoriesMetaTitle',
    metaDescriptionKey: 'SearchPage.campingAccessoriesMetaDescription',
  },
  {
    countries: [],
    key: 'watersports_lifejacket',
    pageName: 'WatersportsLifejacketSearchPage',
    translationKey: 'urls.watersportsLifejacketRent',
    headerKey: 'SearchPage.watersportsLifejacketHeader',
    descriptionKey: 'SearchPage.watersportsLifejacketDescription',
    metaTitleKey: 'SearchPage.watersportsLifejacketMetaTitle',
    metaDescriptionKey: 'SearchPage.watersportsLifejacketMetaDescription',
  },
  {
    countries: ['pl', 'cz', 'sk', 'hu', 'lt', 'lv', 'ee'],
    key: 'camping_tent',
    pageName: 'CampingTentSearchPage',
    translationKey: 'urls.campingTentRent',
    headerKey: 'SearchPage.campingTentHeader',
    descriptionKey: 'SearchPage.campingTentDescription',
    metaTitleKey: 'SearchPage.campingTentMetaTitle',
    metaDescriptionKey: 'SearchPage.campingTentMetaDescription',
  },
  {
    countries: ['cz', 'sk', 'hu'],
    key: 'camping_rooftent',
    pageName: 'CampingRoofTentSearchPage',
    translationKey: 'urls.campingRoofTentRent',
    headerKey: 'SearchPage.campingRoofTentHeader',
    descriptionKey: 'SearchPage.campingRoofTentDescription',
    metaTitleKey: 'SearchPage.campingRoofTentMetaTitle',
    metaDescriptionKey: 'SearchPage.campingRoofTentMetaDescription',
  },
  {
    countries: ['pl', 'cz', 'hu', 'lt', 'lv', 'ee'],
    key: 'bikes_mountain',
    pageName: 'MountainBikesSearchPage',
    translationKey: 'urls.bikesMountainRent',
    headerKey: 'SearchPage.bikesMountainHeader',
    descriptionKey: 'SearchPage.bikesMountainDescription',
    metaTitleKey: 'SearchPage.bikesMountainMetaTitle',
    metaDescriptionKey: 'SearchPage.bikesMountainMetaDescription',
  },
  {
    countries: ['pl', 'cz', 'sk', 'lv', 'ee', 'hu'],
    key: 'tourism_carrier',
    pageName: 'TourismCarrierSearchPage',
    translationKey: 'urls.tourismCarrierRent',
    headerKey: 'SearchPage.tourismCarrierHeader',
    descriptionKey: 'SearchPage.tourismCarrierDescription',
    metaTitleKey: 'SearchPage.tourismCarrierMetaTitle',
    metaDescriptionKey: 'SearchPage.tourismCarrierMetaDescription',
  },
  {
    countries: ['cz'],
    key: 'tourism_tent',
    pageName: 'TourismTentSearchPage',
    translationKey: 'urls.tourismTentRent',
    headerKey: 'SearchPage.tourismTentHeader',
    descriptionKey: 'SearchPage.tourismTentDescription',
    metaTitleKey: 'SearchPage.tourismTentMetaTitle',
    metaDescriptionKey: 'SearchPage.tourismTentMetaDescription',
  },
  {
    countries: ['pl', 'cz', 'sk', 'hu', 'lt', 'lv', 'ee'],
    key: 'watersports_sup',
    pageName: 'WatersportsSupSearchPage',
    translationKey: 'urls.watersportsSupRent',
    headerKey: 'SearchPage.watersportsSupHeader',
    descriptionKey: 'SearchPage.watersportsSupDescription',
    metaTitleKey: 'SearchPage.watersportsSupMetaTitle',
    metaDescriptionKey: 'SearchPage.watersportsSupMetaDescription',
  },
  {
    countries: [],
    key: 'tourism_sticks',
    pageName: 'TourismSticksSearchPage',
    translationKey: 'urls.tourismSticksRent',
    headerKey: 'SearchPage.tourismSticksHeader',
    descriptionKey: 'SearchPage.tourismSticksDescription',
    metaTitleKey: 'SearchPage.tourismSticksMetaTitle',
    metaDescriptionKey: 'SearchPage.tourismSticksMetaDescription',
  },
  {
    countries: ['pl', 'sk', 'cz', 'hu'],
    key: 'bikes_road',
    pageName: 'BikesRoadSearchPage',
    translationKey: 'urls.bikesRoadRent',
    headerKey: 'SearchPage.bikesRoadHeader',
    descriptionKey: 'SearchPage.bikesRoadDescription',
    metaTitleKey: 'SearchPage.bikesRoadMetaTitle',
    metaDescriptionKey: 'SearchPage.bikesRoadMetaDescription',
  },
  {
    countries: ['pl'],
    key: 'tourism_axe',
    pageName: 'TourismAxeSearchPage',
    translationKey: 'urls.tourismAxeRent',
    headerKey: 'SearchPage.tourismAxeHeader',
    descriptionKey: 'SearchPage.tourismAxeDescription',
    metaTitleKey: 'SearchPage.tourismAxeMetaTitle',
    metaDescriptionKey: 'SearchPage.tourismAxeMetaDescription',
  },
  {
    countries: ['pl', 'cz'],
    key: 'bikes_treadmill',
    pageName: 'BikesTreadmillSearchPage',
    translationKey: 'urls.bikesTreadmillRent',
    headerKey: 'SearchPage.bikesTreadmillHeader',
    descriptionKey: 'SearchPage.bikesTreadmillDescription',
    metaTitleKey: 'SearchPage.bikesTreadmillMetaTitle',
    metaDescriptionKey: 'SearchPage.bikesTreadmillMetaDescription',
  },
  {
    countries: ['pl', 'cz'],
    key: 'tourism_snowshoes',
    pageName: 'TourismSnowshoesSearchPage',
    translationKey: 'urls.tourismSnowshoesRent',
    headerKey: 'SearchPage.tourismSnowshoesHeader',
    descriptionKey: 'SearchPage.tourismSnowshoesDescription',
    metaTitleKey: 'SearchPage.tourismSnowshoesMetaTitle',
    metaDescriptionKey: 'SearchPage.tourismSnowshoesMetaDescription',
  },
  {
    countries: ['pl'],
    key: 'bikes_seat',
    pageName: 'BikesSeatSearchPage',
    translationKey: 'urls.bikesSeatRent',
    headerKey: 'SearchPage.bikesSeatHeader',
    descriptionKey: 'SearchPage.bikesSeatDescription',
    metaTitleKey: 'SearchPage.bikesSeatMetaTitle',
    metaDescriptionKey: 'SearchPage.bikesSeatMetaDescription',
  },
  {
    countries: ['pl'],
    key: 'transport_bikes',
    pageName: 'TransportBikesSearchPage',
    translationKey: 'urls.transportBikesRent',
    headerKey: 'SearchPage.transportBikesHeader',
    descriptionKey: 'SearchPage.transportBikesDescription',
    metaTitleKey: 'SearchPage.transportBikesMetaTitle',
    metaDescriptionKey: 'SearchPage.transportBikesMetaDescription',
  },
  {
    countries: ['pl', 'cz'],
    key: 'wintersports_crosscountry',
    pageName: 'WintersportsCrosscountrySearchPage',
    translationKey: 'urls.wintersportsCrosscountryRent',
    headerKey: 'SearchPage.wintersportsCrosscountryHeader',
    descriptionKey: 'SearchPage.wintersportsCrosscountryDescription',
    metaTitleKey: 'SearchPage.wintersportsCrosscountryMetaTitle',
    metaDescriptionKey: 'SearchPage.wintersportsCrosscountryMetaDescription',
  },
  {
    countries: ['cz'],
    key: 'wintersports_other',
    pageName: 'WintersportsOtherSearchPage',
    translationKey: 'urls.wintersportsOtherRent',
    headerKey: 'SearchPage.wintersportsOtherHeader',
    descriptionKey: 'SearchPage.wintersportsOtherDescription',
    metaTitleKey: 'SearchPage.wintersportsOtherMetaTitle',
    metaDescriptionKey: 'SearchPage.wintersportsOtherMetaDescription',
  },
  {
    countries: ['pl', 'cz', 'sk'],
    key: 'bikes_trailer',
    pageName: 'BikesTrailerSearchPage',
    translationKey: 'urls.bikesTrailerRent',
    headerKey: 'SearchPage.bikesTrailerHeader',
    descriptionKey: 'SearchPage.bikesTrailerDescription',
    metaTitleKey: 'SearchPage.bikesTrailerMetaTitle',
    metaDescriptionKey: 'SearchPage.bikesTrailerMetaDescription',
  },
  {
    countries: [],
    key: 'bikes_city',
    pageName: 'BikesCitySearchPage',
    translationKey: 'urls.bikesCityRent',
    headerKey: 'SearchPage.bikesCityHeader',
    descriptionKey: 'SearchPage.bikesCityDescription',
    metaTitleKey: 'SearchPage.bikesCityMetaTitle',
    metaDescriptionKey: 'SearchPage.bikesCityMetaDescription',
  },
  {
    countries: ['pl', 'cz', 'hu', 'lt', 'lv', 'ee', 'sk'],
    key: 'watersports_kayak',
    pageName: 'WatersportsKayakSearchPage',
    translationKey: 'urls.watersportsKayakRent',
    headerKey: 'SearchPage.watersportsKayakHeader',
    descriptionKey: 'SearchPage.watersportsKayakDescription',
    metaTitleKey: 'SearchPage.watersportsKayakMetaTitle',
    metaDescriptionKey: 'SearchPage.watersportsKayakMetaDescription',
  },
  {
    countries: ['cz', 'sk'],
    key: 'watersports_accessories',
    pageName: 'WatersportsAccessoriesSearchPage',
    translationKey: 'urls.watersportsAccessoriesRent',
    headerKey: 'SearchPage.watersportsAccessoriesHeader',
    descriptionKey: 'SearchPage.watersportsAccessoriesDescription',
    metaTitleKey: 'SearchPage.watersportsAccessoriesMetaTitle',
    metaDescriptionKey: 'SearchPage.watersportsAccessoriesMetaDescription',
  },
  {
    countries: ['cz', 'sk', 'lv', 'ee', 'pl'],
    key: 'fitness_cardio',
    pageName: 'FitnessCardioSearchPage',
    translationKey: 'urls.fitnessCardioRent',
    headerKey: 'SearchPage.fitnessCardioHeader',
    descriptionKey: 'SearchPage.fitnessCardioDescription',
    metaTitleKey: 'SearchPage.fitnessCardioMetaTitle',
    metaDescriptionKey: 'SearchPage.fitnessCardioMetaDescription',
  },
  {
    countries: ['sk'],
    key: 'bikes_accessories',
    pageName: 'BikesAccessoriesSearchPage',
    translationKey: 'urls.bikesAccessoriesRent',
    headerKey: 'SearchPage.bikesAccessoriesHeader',
    descriptionKey: 'SearchPage.bikesAccessoriesDescription',
    metaTitleKey: 'SearchPage.bikesAccessoriesMetaTitle',
    metaDescriptionKey: 'SearchPage.bikesAccessoriesMetaDescription',
  },
]; 